import type { ButtonProps, ThemeProps, ThemeTokens } from '@atlaskit/button';
import Button from '@atlaskit/button/custom-theme-button';
import { token } from '@atlaskit/tokens';
import React from 'react';

type AtlasPrimaryOnboardingButtonProps = {
  width?: string;
  label: string;
  icon?: React.ReactChild;
  href?: string;
} & Pick<ButtonProps, 'isSelected' | 'onClick'> &
  React.HTMLAttributes<HTMLButtonElement>;

export function AtlasPrimaryOnboardingButton({
  label,
  icon,
  isSelected,
  onClick,
  href,
  ...divProps
}: AtlasPrimaryOnboardingButtonProps) {
  const buttonTheme = (currentTheme: (props: ThemeProps) => ThemeTokens, themeProps: ThemeProps) => {
    const { buttonStyles, spinnerStyles } = currentTheme(themeProps);

    const isHover = themeProps.state === 'hover';

    return {
      buttonStyles: {
        ...buttonStyles,
        color: isSelected ? token('color.text') : token('color.text.inverse'),
        background: isSelected
          ? isHover
            ? token('color.background.neutral')
            : token('color.background.neutral.hovered')
          : isHover
          ? token('color.background.brand.bold.hovered')
          : token('color.background.brand.bold'),
        borderRadius: '90px',
        height: '38px',
        padding: `10px ${token('space.150')}`,
        justifyContent: 'center',
        alignItems: 'center',
        transition: 'width 500ms linear',
      },
      spinnerStyles,
    };
  };

  return (
    <Button
      {...divProps}
      theme={buttonTheme}
      isSelected={isSelected}
      onClick={onClick}
      href={href}
      iconBefore={icon}
      appearance="primary"
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
      className="what-is-atlas-button"
      target="_blank"
      rel="noopener noreferrer"
    >
      {label}
    </Button>
  );
}
